// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.bubble {
  position: relative;
  width: 300px;
  text-align: center;
  line-height: 1.4em;
  margin: 40px auto;
  background-color: #fff;
  border: 8px solid #333;
  border-radius: 30px;
  font-family: sans-serif;
  padding: 20px;
  font-size: large;
  left: 20%;
  top: 50px;
}

div.thought {
  width: 300px;
  border-radius: 200px;
  padding: 30px;
}

div.bubble:before,
div.bubble:after {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
}

div.speech:before {
  left: 30px;
  bottom: -50px;
  border: 25px solid;
  border-color: #333 transparent transparent #333;
}

div.speech:after {
  left: 38px;
  bottom: -30px;
  border: 15px solid;
  border-color: #fff transparent transparent #fff;
}

div.thought:before,
div.thought:after {
  left: 10px;
  bottom: -30px;
  width: 40px;
  height: 40px;
  background-color: #fff;
  border: 8px solid #333;
  border-radius: 28px;
}

div.thought:after {
  width: 20px;
  height: 20px;
  left: 5px;
  bottom: -40px;
  border-radius: 18px;
}

@media (max-width: 425px) {
  div.bubble {
    width: 250px;
    left: 35px;
    top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/screens/WaitingRoom.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;;EAEE,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EAGtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,UAAU;IACV,SAAS;EACX;AACF","sourcesContent":["div.bubble {\n  position: relative;\n  width: 300px;\n  text-align: center;\n  line-height: 1.4em;\n  margin: 40px auto;\n  background-color: #fff;\n  border: 8px solid #333;\n  border-radius: 30px;\n  font-family: sans-serif;\n  padding: 20px;\n  font-size: large;\n  left: 20%;\n  top: 50px;\n}\n\ndiv.thought {\n  width: 300px;\n  border-radius: 200px;\n  padding: 30px;\n}\n\ndiv.bubble:before,\ndiv.bubble:after {\n  content: ' ';\n  position: absolute;\n  width: 0;\n  height: 0;\n}\n\ndiv.speech:before {\n  left: 30px;\n  bottom: -50px;\n  border: 25px solid;\n  border-color: #333 transparent transparent #333;\n}\n\ndiv.speech:after {\n  left: 38px;\n  bottom: -30px;\n  border: 15px solid;\n  border-color: #fff transparent transparent #fff;\n}\n\ndiv.thought:before,\ndiv.thought:after {\n  left: 10px;\n  bottom: -30px;\n  width: 40px;\n  height: 40px;\n  background-color: #fff;\n  border: 8px solid #333;\n  -webkit-border-radius: 28px;\n  -moz-border-radius: 28px;\n  border-radius: 28px;\n}\n\ndiv.thought:after {\n  width: 20px;\n  height: 20px;\n  left: 5px;\n  bottom: -40px;\n  -webkit-border-radius: 18px;\n  -moz-border-radius: 18px;\n  border-radius: 18px;\n}\n\n@media (max-width: 425px) {\n  div.bubble {\n    width: 250px;\n    left: 35px;\n    top: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
